(function() {
	'use strict';
	angular.module('app.core')
		.service('a3Service', a3Service);
	
	a3Service.$inject = ['$http', '$rootScope', 'URLS'];
	function a3Service($http, $rootScope, URLS) {
		var taskPriorityNumeric = {
			'High': 3,
			'Medium': 2,
			'Low': 1
		};
		return {
			getProjectGeneralData: getProjectGeneralData,
			getProjectTeam: getProjectTeam,
			getProjectIssues: getProjectIssues,
			getProjectTasks: getProjectTasks,
			getProjectDocuments: getProjectDocuments,
			getProjectDocument: getProjectDocument,
			getStartAndEndDates: getStartAndEndDates,
			getFactorySettings: getFactorySettings,
			getTaskPriority: getTaskPriority,
			getProjectSavingsByCategory: getProjectSavingsByCategory
		};

		function getProjectGeneralData(projectNdx, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx;
			return $http.get(URLS.host + url)
				.then(getProjectGeneralDataComplete)
				.catch(getProjectGeneralDataFailed);

			function getProjectGeneralDataComplete(response) {
				return response.data;
			}

			function getProjectGeneralDataFailed(error) {
				return undefined;
			}
		}

		function getProjectTeam(projectNdx, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx + '/TeamMembers';
			return $http.get(URLS.host + url)
				.then(getProjectTeamComplete)
				.catch(getProjectTeamFailed);

			function getProjectTeamComplete(response) {
				return response.data;
			}

			function getProjectTeamFailed(error) {
				return undefined;
			}
		}

		function getProjectIssues(projectNdx, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx + '/Issues';
			return $http.get(URLS.host + url)
				.then(getProjectIssuesComplete)
				.catch(getProjectIssuesFailed);

			function getProjectIssuesComplete(response) {
				return response.data;
			}

			function getProjectIssuesFailed(error) {
				return undefined;
			}
		}

		function getProjectTasks(projectNdx, status, reviewFrequency, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx + '/TasksByStatus?status=' + status;
			if (typeof reviewFrequency != 'undefined') {
				url += '&applyRevFreq=' + reviewFrequency;
			}
			return $http.get(URLS.host + url)
				.then(getProjectTasksComplete)
				.catch(getProjectTasksFailed);

			function getProjectTasksComplete(response) {
				return response.data;
			}

			function getProjectTasksFailed(error) {
				return undefined;
			}
		}

		function getProjectDocuments(projNdx, leanDirFactoryNdx) {
			return $http.get(URLS.host + URLS.prefix + leanDirFactoryNdx + '/LeanProject/' + projNdx + '/Documents')
				.then(getDocumentsSuccess, getDocumentsError);

			function getDocumentsSuccess(response) {
				return response.data;
			}

			function getDocumentsError() {
				// TODO: Show some type of error message
			}
		}

		function getProjectDocument(projNdx, leanDirFactoryNdx, docName) {
			jQuery.fileDownload(URLS.host + URLS.prefix + leanDirFactoryNdx + '/LeanProject/' + projNdx + '/Document/' + docName, {
				httpMethod: 'GET',
				encodeHTMLEntities: false,
				successCallback: function (url) {},
				failCallback: function (responseHtml, url) {
					$rootScope.$emit('toast', {
						'message': 'Unable to Download Document',
						'success': false
					});
				}
			});
		}

		function getFactorySettings(factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/FactoryControlVariables/group/StrategyDeployment/family/Report/variable/StrategyDeploymentReviewFrequency';
			return $http.get(URLS.host + url)
				.then(getFactorySettingsComplete)
				.catch(getFactorySettingsFailed);

			function getFactorySettingsComplete(response) {
				return response.data;
			}

			function getFactorySettingsFailed(error) {
				return undefined;
			}
		}

		function getStartAndEndDates(factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/FactoryControlVariables/FactoryMetricDateRange';
			return $http.get(URLS.host + url)
				.then(getStartAndEndDatesComplete)
				.catch(getStartAndEndDatesFailed);

			function getStartAndEndDatesComplete(response) {
				return response.data;
			}

			function getStartAndEndDatesFailed(error) {
				return undefined;
			}
		}

		function getTaskPriority(taskPriority) {
			return taskPriorityNumeric[taskPriority];
		}
		
		function getProjectSavingsByCategory(factoryNdx, projectNdx) {
			var url = URLS.prefix + factoryNdx + '/LeanProject/' + projectNdx + '/ProjectSavingsByCategory';
			return $http.get(URLS.host + url)
				.then(getProjectSavingsByCategoryComplete)
				.catch(getProjectSavingsByCategoryFailed);

			function getProjectSavingsByCategoryComplete(response) {
				return response.data;
			}

			function getProjectSavingsByCategoryFailed(error) {
				return undefined;
			}
		}
	}
})();